import React from 'react'
// import PropTypes from 'prop-types'
import styled from 'styled-components';
import { Checkbox } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import moment from 'moment';
// import ExcelIcon from '../../../../assets/icons/ic_excel.svg';
// import SendIcon from '../../../../assets/icons/ic_send-email.svg';

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  background: #FFFFFF;
  padding: 1em;
  border-bottom: 1px solid #efefef;
  @media screen and (max-width: 500px) {
    width: max-content;
  }
`
const DateTxt = styled.span`
  font-family: Open Sans;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 22px;
  color: #333333;
  margin-bottom: .2em;
  text-transform: capitalize;
`
const ColumnDiv = styled.div`
  display: flex;
  flex-direction: column;
  margin: ${({margin=0})=> margin};
  align-self: ${({alignSelf='initial'})=> alignSelf};
  @media screen and (max-width: 500px) {
    margin: ${({marginMobile}) => marginMobile};
  }
`
const RowDiv = styled.div`
  display: flex;
  flex-direction: row;
  align-items: ${({alignItems='center'}) => alignItems};
  margin: ${({margin=0})=> margin};
  align-self: ${({alignSelf='initial'})=> alignSelf};
  @media screen and (max-width: 500px) {
    margin: ${({marginMobile}) => marginMobile};
  }
`
const NumberManifest = styled.span`
  font-family: Open Sans;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 18px;
  color: #F15B5B;
  & span{
    font-weight: 500;
  }
`
const ClipBoardIC = styled.img`
  height: 16px;
  width: 16px;
  margin-right: .3em;
`
const DetailTxt = styled.span`
  font-family: Open Sans;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 18px;
  color: #6A6A6A;
  & span {
    font-weight: 500;
  }
`
const IconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${({color='#5E388A'}) => color};
  width: 40px;
  height: 40px;
  border-radius: 160px;
  margin-right: 1em;
  cursor: pointer;
`
const SendIcon = styled.img`
  margin-top: 2.5px;
  height: 19px;
  width: 20px;
`
const ExcelIcon = styled.img`
  height: 17.5px;
  width: 20px;
`
const PapperCheckIc = styled.img`
  height: 13.5px;
  width: 13.5px;
  margin-right: .5em;
`
const ChevronRight = styled.img`
  height: 32px;
  width: 32px;
  cursor: pointer;
`
const PurpleCheckbox = withStyles({
  root: {
    color: '#CFD4D8',
    '&$checked': {
      color: '#5E388A',
    },
  },
  checked: {},
})(props => <Checkbox color="default" {...props} />);

const ItemHistory = ({ row, rowIndex, onClickCheckBox, checked, registerDate, manifestCount, ticketsNumber, onClickDetail, onClickSend, onClickExport }) => {
  return (
    <Container>
      <RowDiv marginMobile='0 1.5em 0 0'>
        <PurpleCheckbox checked={checked} onClick={() => onClickCheckBox(row, rowIndex)}/>
        <ColumnDiv>
          <DateTxt>{ moment.utc(registerDate).format('ddd [  ]DD MMM YYYY') ||  'Mié, 20 may. 2020 - 10:34 a.m.' }</DateTxt>
          <RowDiv>
            <ClipBoardIC src={require('../../../../assets/icons/ic_web_clipboard-alt.svg')} />
            <NumberManifest><span>{manifestCount}</span> manifiestos creados</NumberManifest>
          </RowDiv>
        </ColumnDiv>
      </RowDiv>
      <ColumnDiv marginMobile='0 1.5em 0 0' alignSelf='flex-end'>
        {/* <RowDiv>
          <TruckIcon src={require('../../../../assets/icons/ic_truck.svg')} />
          <DetailTxt>Inter Logistics S.A.C</DetailTxt>
        </RowDiv> */}
        <RowDiv>
          <PapperCheckIc src={require('../../../../assets/icons/ic_papper-check.svg')} />
          <DetailTxt><span>{ticketsNumber}</span> tickets escaneados</DetailTxt>
        </RowDiv>
      </ColumnDiv>
      <RowDiv>
        <IconContainer onClick={() => onClickSend(row.registerDate)} color='#F15B5B'>
          <SendIcon src={require('../../../../assets/icons/ic_send-email.svg')}/>
        </IconContainer>
        <IconContainer onClick={() => onClickExport(row.registerDate)}>
          <ExcelIcon src={require('../../../../assets/icons/ic_excel.svg')}/>
        </IconContainer>
        <ChevronRight onClick={onClickDetail} src={require('../../../../assets/icons/ic_chevron-right_2.svg')}/>
      </RowDiv>
    </Container>
  )
}

export default ItemHistory
